import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import { ProfileImageWidget } from "./components/profile-image/profile-image-widget";

function ProfileImageRenderer() {
  const rootElement = document.getElementById(
    "my-profile__profile-image-widget"
  );
  if (!rootElement) return;

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ProfileImageWidget
          avatarUrl={rootElement.dataset.avatarUrl}
          externalAvatarUrl={rootElement.dataset.externalAvatarUrl}
          avatarInitials={rootElement.dataset.avatarInitials}
        />
      </QueryClientProvider>
    </StrictMode>
  );
}

export const initProfileImage = () => {
  if (document.readyState !== "loading") {
    ProfileImageRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", ProfileImageRenderer);
  }
};
